import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { getLocationPathByPaymentOwner } from '../common';
import {
	requestAccessToken,
	STRIPE_ACCESS_TOKEN_REQUEST, STRIPE_ACCESS_TOKEN_SUCCESS, STRIPE_ACCESS_TOKEN_FAILURE
} from './actions';
import { Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import browserStorage from '../../../../common/services/browserStorage';

class AuthorizationCallback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accessTokenError: ''
		};
	}

	componentDidMount() {
		const { queryParams: { code }, storedData: { useSandbox, paymentConfigurationId }, history } = this.props;
		if (code) {
			const redirectToPaymentMethods = () => history.push(this.getBackPath());

			this.props.requestAccessToken({ code, paymentConfigurationId, useSandbox },
				redirectToPaymentMethods,
				(error) => this.setState({ accessTokenError: error }));
		}
	}

	getBackPath() {
		const { storedData: { paymentOwnerType, paymentOwnerId, franchiseeId } } = this.props;

		return `${getLocationPathByPaymentOwner(paymentOwnerType, paymentOwnerId, franchiseeId)}?method=stripe`;
	}

	render() {
		const { queryParams: { error, error_description }, t } = this.props;

		const backPath = this.getBackPath();

		const errorMessage = (error && error_description) || this.state.accessTokenError;

		return <ReduxBlockUi block={STRIPE_ACCESS_TOKEN_REQUEST} unblock={[STRIPE_ACCESS_TOKEN_SUCCESS, STRIPE_ACCESS_TOKEN_FAILURE]} renderChildren={false}>
			{errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
			{!errorMessage && <Alert bsStyle='success'>{t('Stripe_OAuth_Success')}</Alert>}
			<Link to={backPath} className='btn btn-default'>{t('Common_Back')}</Link>
		</ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { configuration: { franchisor } } = state;
	const queryParams = queryString.parse(ownProps.location.search);
	// required data is stored in local storage before redirecting to Stripe authorization page, "state" param contains the local storage key
	const storedData = JSON.parse(browserStorage.getFromSessionStorage(franchisor, queryParams.state));

	return {
		queryParams,
		storedData
	};
};

export default connect(mapStateToProps, {
	requestAccessToken
})(withTranslation()(AuthorizationCallback));